import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
export function AIEdit24() {
    return /*#__PURE__*/ _jsxs("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M13.7902 7.12003C14.5602 9.88003 16.7202 12.04 19.4902 12.82M15.0902 5.82003L6.00016 14.91C5.65016 15.26 5.31016 15.94 5.24016 16.43L4.74016 19.9C4.56016 21.16 5.44016 22.04 6.70016 21.86L10.1702 21.36C10.6502 21.29 11.3402 20.94 11.6902 20.6L20.7902 11.5C22.3602 9.93003 23.1002 8.11003 20.7902 5.80003C18.4802 3.49003 16.6602 4.23003 15.0902 5.80003V5.82003Z",
                stroke: "currentColor",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M6.18 1.79986C6.25 1.62986 6.5 1.62986 6.57 1.79986L7.72 4.52986C7.74 4.57986 7.78 4.61986 7.83 4.63986L10.56 5.78986C10.73 5.85986 10.73 6.10986 10.56 6.17986L7.83 7.32986C7.78 7.34986 7.74 7.38986 7.72 7.43986L6.57 10.1699C6.5 10.3399 6.25 10.3399 6.18 10.1699L5.03 7.43986C5.01 7.38986 4.97 7.34986 4.92 7.32986L2.19 6.17986C2.02 6.10986 2.02 5.85986 2.19 5.78986L4.92 4.63986C4.97 4.61986 5.01 4.57986 5.03 4.52986L6.18 1.79986Z",
                stroke: "currentColor",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
}
